import { render } from "./shipping-promo.vue?vue&type=template&id=62f0b1ee"
import script from "./shipping-promo.vue?vue&type=script&lang=js"
export * from "./shipping-promo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__